import words from '../content/words';

export default function wordsReducers(state = words, action) {
	return state;
}


// WEBPACK FOOTER //
// ./src/reducers/words.js